export const STATUS_STYLE = {
  online: {
    badge: "text-green-700 bg-green-50 border border-green-300",
    dot: "bg-green-500",
  },
  offline: {
    badge: "text-gray-500 bg-gray-50 border border-gray-200",
    dot: "bg-gray-400",
  },
};

/** statuses that count as "reachable" for filtering */
export const ONLINE_STATUSES = new Set(["online"]);
